import { VenueValues } from './places';
import { TimezoneValues } from './timezone';

export enum LocationType {
    Venue = 'venue',
    Online = 'online',
    ToBeAnnounced = 'to_be_announced',
}

export enum FormField {
    Title = 'title',
    Dates = 'dates',
    StartTime = 'startTime',
    EndTime = 'endTime',
    LocationType = 'locationType',
    TicketsPrice = 'ticketsPrice',
    AreTicketsFree = 'areTicketsFree',
    TicketsAvailable = 'ticketsAvailable',
    LocationAddress2 = 'locationAddress2',
    Venue = 'venue',
    Timezone = 'timezone',
}

// TODO: Ideally we should use dynamic object keys here.
export type FormValues = {
    title: string;
    dates: Date[];
    startTime: string;
    endTime: string;
    locationType: LocationType;
    ticketsPrice: string;
    areTicketsFree: boolean;
    ticketsAvailable: string;
    venue: VenueValues;
    locationAddress2?: string;
    timezone: TimezoneValues;
    showVenueOptions: boolean;
};
